__turbopack_context__.v({
  "container": "Card-module-scss-module__YNMKKW__container",
});
